import { Observable } from './druid/./druid/Observable';
import { of as staticOf } from './druid/./druid/observable/of';

Observable.of = staticOf;

declare module './druid/./druid/Observable' {
  namespace Observable {
    export let of: typeof staticOf; //formOf an iceberg!
  }
}